/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessStoryResponseAdminDto } from '../../models/success-story-response-admin-dto';

export interface AdminSuccessStoriesControllerTogglePublishV1$Params {
  id: string;
}

export function adminSuccessStoriesControllerTogglePublishV1(http: HttpClient, rootUrl: string, params: AdminSuccessStoriesControllerTogglePublishV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessStoryResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminSuccessStoriesControllerTogglePublishV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessStoryResponseAdminDto>;
    })
  );
}

adminSuccessStoriesControllerTogglePublishV1.PATH = '/v1/admin/success-stories/{id}/publish';
